import {
  SlideAdminList,
  Block,
  CaseDocument,
  CaseDocumentAdmin,
  CaseSpecimenAdmin,
  Slide,
  SlideAdmin,
  SpecimenAdmin,
} from "pwapi";

const lisBase =
  process.env.REACT_APP_LIS_DOMAIN ||
  `lis${process.env.REACT_APP_COOKIE_DOMAIN}`;
const viewerBase =
  process.env.REACT_APP_VIEWER_DOMAIN ||
  `app${process.env.REACT_APP_COOKIE_DOMAIN}`;
export const lisURL = `${process.env.REACT_APP_BACKEND_PROTOCOL}://${lisBase}`;
export const viewerURL = `${process.env.REACT_APP_BACKEND_PROTOCOL}://${viewerBase}`;

export const printBlocksLink = (
  caseId: number,
  blocks: Block | Block[],
  printer: "zebra" | "ipc" = "zebra",
  relative = false
) => {
  if (!Array.isArray(blocks)) blocks = [blocks];

  return `${relative ? "" : lisURL}/print/${caseId}/?blocks=${blocks
    .map((b) => b.id)
    .join(",")}${printer ? `&printer=${printer}` : ""}`;
};

type SpecimensUnion = SpecimenAdmin | CaseSpecimenAdmin;
export const printSpecimensLink = (
  caseId: number,
  specimens: SpecimensUnion | SpecimensUnion[],
  relative = false
) => {
  if (!Array.isArray(specimens)) specimens = [specimens];

  return `${relative ? "" : lisURL}/print/${caseId}/?specimens=${specimens
    .map((s) => s.id)
    .join(",")}`;
};

type SlideUnion = SlideAdmin | Slide | SlideAdminList;
export const printSlidesLink = (
  caseId: number,
  slides: SlideUnion | SlideUnion[],
  printer?: "zebra" | "espo",
  relative = false
) => {
  if (!Array.isArray(slides)) slides = [slides];

  return `${relative ? "" : lisURL}/print/${caseId}/?slides=${slides
    .map((s) => s.id)
    .join(",")}${printer ? `&printer=${printer}` : ""}`;
};

export const batchPrintSlidesLink = (
  caseIds: number[],
  slideIds: number[],
  printer?: "zebra" | "espo",
  relative = false
) => {
  return `${relative ? "" : lisURL}/batch_print/${caseIds.join(
    ","
  )}/?slides=${slideIds.join(",")}${printer ? `&printer=${printer}` : ""}`;
};

type CaseDocumentUnion = CaseDocument | CaseDocumentAdmin;
export const printDocumentsLink = (
  caseId: number,
  documents: CaseDocumentUnion | CaseDocumentUnion[],
  relative = false
) => {
  if (!Array.isArray(documents)) documents = [documents];

  return `${relative ? "" : lisURL}/print/${caseId}/?documents=${documents
    .map((s) => s.id)
    .join(",")}`;
};

export const printSendoutRequisitionLink = (
  caseId: number,
  relative = false
) => {
  return `${relative ? "" : lisURL}/cases/${caseId}/sendout_requisition`;
};
